import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { Trans } from '@lingui/macro';
import { Typography } from 'antd';

import { ButtonProps, Button } from 'components/AntD';

export interface ActionButtonsProps {
  size?: ButtonProps['size'];
  className?: string;
  secondaryActionText?: ReactNode;
  secondaryActionCallback?(): void;
  primaryActionText?: ReactNode;
  primaryActionCallback?(): void;
  error?: ReactNode | boolean;
  isLoading?: boolean;
  danger?: boolean;
  rounded?: boolean;
  type?: ButtonProps['htmlType'];
  primaryActionProps?: Partial<Omit<ButtonProps, 'color'>>;
  secondaryActionProps?: Partial<Omit<ButtonProps, 'color'>>;
}

export default function ActionButtons({
  size = 'large',
  className = '',
  secondaryActionCallback,
  secondaryActionText = <Trans>Cancel</Trans>,
  primaryActionText = <Trans>OK</Trans>,
  primaryActionCallback = () => void 0,
  isLoading = false,
  error = false,
  danger = false,
  rounded = false,
  type = 'submit',
  primaryActionProps = {},
  secondaryActionProps = {},
}: ActionButtonsProps): JSX.Element {
  return (
    <div
      className={classNames('btn-wrapper tw-flex tw-gap-4 tw-flex-wrap', className, {
        'tw-justify-between': !!secondaryActionCallback,
        'tw-justify-around tw-flex-col': !secondaryActionCallback,
        'btn-wrapper-lg': size === 'large',
      })}
    >
      {secondaryActionText && secondaryActionCallback && (
        <Button
          htmlType="reset"
          onClick={secondaryActionCallback}
          size={size}
          shape={size === 'large' ? 'round' : void 0}
          block={size === 'large'}
          disabled={isLoading || secondaryActionProps?.disabled}
          variant="outlined"
          {...secondaryActionProps}
        >
          {secondaryActionText}
        </Button>
      )}
      {error && (
        <Typography.Text
          type="danger"
          className={classNames('tw-text-sm', {
            'tw-text-left': !!secondaryActionCallback,
            'tw-text-center': !secondaryActionCallback,
          })}
        >
          {error}
        </Typography.Text>
      )}
      {primaryActionCallback && (
        <Button
          htmlType={type}
          variant="contained"
          color="primary"
          className="primary-button"
          onClick={primaryActionCallback}
          size={size}
          block={size === 'large'}
          disabled={isLoading || primaryActionProps?.disabled}
          shape={rounded ? 'round' : void 0}
          loading={isLoading}
          danger={danger}
          {...primaryActionProps}
        >
          {primaryActionText}
        </Button>
      )}
    </div>
  );
}
